// MBO Niveau 3 Studies
// Advanced vocational studies with specializations and categories

export const MBO_NIVEAU_3_STUDIES = {
  'Techniek, Bouw & Productie': {
    'Werktuigbouw & Elektrotechniek': [
      'Eerste monteur datadistributie',
      'Eerste monteur middenspanningsdistributie',
      'Eerste monteur laagspanningsdistributie',
      'Eerste monteur gas-, water- of warmtedistributie',
      'Eerste monteur elektrotechnische installaties woning en utiliteit',
      'Eerste monteur elektrotechnische industriële installaties en systemen',
      'Eerste monteur service en onderhoud werktuigkundige installaties',
      'Eerste monteur service en onderhoud elektrotechniek en instrumentatie',
      'Eerste monteur koude- en klimaatsystemen',
      'Tekenaar werktuigbouw'
    ],
    'Bouw & Infrastructuur': [
      'Allround metselaar',
      'Allround betonstaalverwerker bouwplaats',
      'Machinist hijswerk',
      'Machinist wegenbouw',
      'Allround dakdekker metaal',
      'Allround dakdekker bitumen en kunststof',
      'Straatmaker',
      'Gezel glaszetter',
      'Eerste monteur utiliteit',
      'Allround betontimmerman',
      'Allround betonreparateur',
      'Allround vakkracht onderhoud- en klussenbedrijf'
    ],
    'Mechatronica & Automatisering': [
      'Eerste monteur mechatronica',
      'Allround technicus voertuigen en mobiele werktuigen',
      'Eerste verbrandingsmotortechnicus',
      'Allround uurwerktechnicus',
      'Allround laborant'
    ],
    'Houtbewerking & Meubelindustrie': [
      'Allround machineoperator houttechniek',
      'Allround machineoperator meubelindustrie / (scheeps)interieurbouw',
      'Allround meubelmaker / (scheeps)interieurbouwer'
    ]
  },
  'Zorg, Welzijn & Dieren': {
    'Gezondheidszorg': [
      'Verzorgende IG',
      'Medewerker steriele medische hulpmiddelen',
      'Pedicure',
      'Orthopedisch schoentechnisch medewerker',
      'Tandtechnisch medewerker basistechnieken'
    ],
    'Maatschappelijke Zorg & Opvang': [
      'Begeleider maatschappelijke zorg',
      'Pedagogisch medewerker kinderopvang',
      'Werkbegeleider zorgboerderij'
    ],
    'Dierverzorging': [
      'Zelfstandig medewerker dierverzorging',
      'Proefdierverzorger'
    ]
  },
  'Veiligheid, Defensie & Toezicht': {
    'Toezicht & Handhaving': [
      'Handhaver toezicht en veiligheid openbaar vervoer (domein IV)',
      'Handhaver toezicht en veiligheid openbare ruimte (domein I)',
      'Handhaver toezicht en veiligheid milieu, welzijn en infrastructuur (domein II)',
      'Handhaver toezicht en veiligheid generieke opsporing (domein VI)'
    ],
    'Defensie & Maritiem': [
      'Aankomend onderofficier maritiem',
      'Aankomend onderofficier grondoptreden'
    ],
    'Havenveiligheid': [
      'Beveiliger 3',
      'Voorman BOR',
      'Balkman',
      'Bootman'
    ]
  },
  'Commercieel, Zakelijk & Mode': {
    'Retail & Verkoop': [
      'Commercieel medewerker',
      'Retailspecialist',
      'Fashion retailer',
      'Assistant fashion tailor'
    ],
    'Horeca & Gastvrijheid': [
      'Zelfstandig werkend gastheer/-vrouw',
      'Zelfstandig werkend kok',
      'Eerste medewerker fastservice'
    ],
    'Administratie & Bedrijfsondersteuning': [
      'Allround assistant business services',
      'Logistiek teamleider',
      'Coördinator internationale havenlogistiek'
    ],
    'Creatieve Ambachten': [
      'Basisgoudsmid'
    ]
  },
  'Vervoer, Transport & Maritiem': {
    'Scheepvaart & Maritiem': [
      'Schipper binnenvaart',
      'Maritiem officier kleine schepen technisch',
      'Maritiem officier kleine schepen nautisch, visserij',
      'Maritiem officier kleine schepen nautisch, koopvaardij'
    ],
    'Weg- & Personenvervoer': [
      'Touringcarchauffeur/reisleider'
    ]
  },
  'Groen, Agrarisch & Landschap': {
    'Tuinbouw & Natuur': [
      'Vakbekwaam medewerker teelt',
      'Vakbekwaam medewerker natuur, water en recreatie',
      'Vakbekwaam medewerker groen, grond en groene infra',
      'Vakbekwaam medewerker bloem, groen en styling'
    ],
    'Veeteelt': [
      'Vakbekwaam medewerker veehouderij'
    ],
    'Hoveniers & Groenvoorziening': [
      'Vakbekwaam hovenier'
    ]
  },
  'Creatieve & Vormgevende Technieken': {
    'Interieur & Meubel': [
      'Allround meubelmaker / (scheeps)interieurbouwer',
      'Allround meubelstoffeerder',
      'Allround interieurvakman parketvloeren',
      'Allround interieurvakman woningstofferen'
    ],
    'Visuele Vormgeving': [
      'Allround signmaker',
      'Allround stand- en decorbouwer'
    ],
    'Technisch Onderhoud & Reparatie': [
      'Gezel schilder',
      'Eerste monteur dakbedekking'
    ],
    'Voertuigentechniek': [
      'Eerste autospuiter'
    ]
  },
  'Logistiek & Productie': {
    'Productieprocessen': [
      'Allround medewerker productietechniek',
      'Procesoperator B'
    ],
    'Logistiek & Distributie': [
      'Logistiek teamleider',
      'Coördinator internationale havenlogistiek'
    ]
  },
  'Media, IT & Ondersteuning': {
    'Media & Vormgeving': [
      'Allround mediamaker',
      'Allround medewerker AV-productie'
    ],
    'IT & Systeemonderhoud': [
      'Allround medewerker IT systems and devices'
    ]
  },
  'Voeding & Vers': {
    'Voeding & Vers': [
      'Allround medewerker versindustrie'
    ]
  }
};

export default MBO_NIVEAU_3_STUDIES;